<template>
  <div>
    <el-dialog
      :id="$options.name"
      :before-close="noDialog"
      :fullscreen="dialogFullscreen"
      :visible.sync="dialog"
      :title="type === 0 ? '创建车库' : '修改车库'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleCloseDialog"
      top="5vh"
    >
      <el-form ref="params" :model="params" :rules="rules" label-width="auto">
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="选择小区" prop="groupId">
              <el-select
                :disabled="type == 1"
                v-model="params.groupId"
                clearable
                placeholder="请选择小区"
                filterable
                ref="select"
                @focus="closeReadOnly"
                @hook:mounted="closeReadOnly"
                @visible-change="closeReadOnly"
              >
                <el-option
                  v-for="item in groupList"
                  :key="item.value"
                  :label="item.groupName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="车库名称" prop="name">
              <el-input v-model="params.name" placeholder="请输入车库名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="位置信息" prop="address">
              <el-row>
                <el-col :span="17" :xs="12">
                  <el-input
                    v-model="params.address"
                    placeholder="请输入位置信息"
                  />
                </el-col>
                <el-col :span="7" :xs="12">
                  <el-button plain type="primary" @click="mapDialog = true"
                    >点击定位</el-button
                  >
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-row>
          <el-col :span="21" :xs="15">
            <el-form-item label="门禁设备" prop="accessControlDeviceList">
              <el-select
                v-model="params.accessControlDeviceList"
                multiple
                placeholder="请选择门禁设备"
              >
                <el-option
                  v-for="item in devices"
                  :key="item.value"
                  :label="item.ids"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3" :xs="9">
            <el-button plain type="primary" @click="handleScanGetAccessDevice"
              >扫码获取</el-button
            >
          </el-col>
        </el-row> -->

        <el-collapse v-model="activeCollapse">
          <el-collapse-item name="0" disabled>
            <template slot="title">
              <div class="collapse_label">
                <Icon
                  :style="{ color: '#67c23a' }"
                  class="label_icon"
                  icon="icon-jin1"
                />
                进门门禁:
              </div>
              <div style="margin-left: 10px">
                <el-button
                  size="mini"
                  plain
                  type="primary"
                  @click="handleScanGetEnterDoorAccessDevice"
                  >扫码获取</el-button
                >
              </div>
            </template>
            <div class="enter_door_wrapper">
              <div
                class="door_item"
                v-for="item in params.accessControlDeviceList.filter(
                  (d) => d.direction == 1
                )"
                :key="item.accessControlDeviceQrCode.id"
              >
                <div class="item_id">
                  <span style="margin-right: 10px"
                    >门禁编号：{{
                      String(item.accessControlDeviceQrCode.id).padStart(6, 0)
                    }}</span
                  >
                  <!-- <el-tag
                    :type="item.onLine ? 'success' : 'danger'"
                    size="small"
                    >{{ item.onLine ? "在线" : "离线" }}</el-tag
                  > -->
                </div>
                <div class="item_btn">
                  <el-button
                    v-if="type == 1"
                    type="warning"
                    size="mini"
                    @click="replaceAccessControl(item)"
                    >更换</el-button
                  >
                  <el-button
                    type="danger"
                    size="mini"
                    @click="delAccessControl(item)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="1" disabled>
            <template slot="title">
              <div class="collapse_label">
                <Icon
                  :style="{ color: '#f56c6c' }"
                  class="label_icon"
                  icon="icon-chu1"
                />
                出门门禁:
              </div>
              <div style="margin-left: 10px">
                <el-button
                  size="mini"
                  plain
                  type="primary"
                  @click="handleScanGetOutDoorAccessDevice"
                  >扫码获取</el-button
                >
              </div>
            </template>
            <div class="out_door_wrapper">
              <div
                class="door_item"
                v-for="item in params.accessControlDeviceList.filter(
                  (d) => d.direction == 2
                )"
                :key="item.accessControlDeviceQrCode.id"
              >
                <div class="item_id">
                  <span style="margin-right: 10px"
                    >门禁编号：{{
                      String(item.accessControlDeviceQrCode.id).padStart(6, 0)
                    }}</span
                  >
                  <!-- <el-tag
                    :type="item.onLine ? 'success' : 'danger'"
                    size="small"
                    >{{ item.onLine ? "在线" : "离线" }}</el-tag
                  > -->
                </div>
                <div class="item_btn">
                  <el-button
                    v-if="type == 1"
                    type="warning"
                    size="mini"
                    @click="replaceAccessControl(item)"
                    >更换</el-button
                  >
                  <el-button
                    type="danger"
                    size="mini"
                    @click="delAccessControl(item)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <div class="collapse_label">
                <Icon
                  :style="{ color: '#f4b646' }"
                  class="label_icon"
                  icon="icon-shoufei"
                />
                临停收费：
              </div>
            </template>
            <el-row :gutter="5">
              <el-col :span="12" :xs="24">
                <div class="collapse_content">
                  <div style="margin-right: 12px">允许临时停车</div>
                  <el-switch v-model="allowTemporaryParking"></el-switch>
                </div>
              </el-col>
            </el-row>
            <el-row
              class="collapse_content"
              :gutter="10"
              v-show="allowTemporaryParking"
            >
              <el-col :span="12" :xs="24">
                <el-row class="collapse_content_wrapper">
                  <el-col :span="4">临停时长</el-col>
                  <el-col :span="20">
                    <el-form-item prop="temporaryParkingTime">
                      <el-input
                        oninput="value=value.replace(/[^\w\s]/g,'')"
                        v-model="params.temporaryParkingTime"
                        placeholder="请输入临停时长"
                      >
                        <template slot="append">小时</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12" :xs="24">
                <el-row class="collapse_content_wrapper">
                  <el-col :span="4">收费金额</el-col>
                  <el-col :span="20">
                    <el-form-item prop="temporaryParkingMoney">
                      <el-input
                        oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        v-model="params.temporaryParkingMoney"
                        placeholder="请输入临停收费金额"
                      >
                        <template slot="append">元</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template slot="title">
              <div class="collapse_label">
                <Icon
                  :style="{ color: '#82b8ff' }"
                  class="label_icon"
                  icon="icon-yuebao"
                />车辆类型包月套餐：
              </div>
            </template>
            <div style="color: #818181">
              <span style="font-weight: bold">温馨提示：</span
              >以下三种场景会导致对应包月套餐下的用户无法续费，用户需要重新开通包月，但不会影响其正常使用
              <div style="margin-top: 6px">1）直接删除某条车辆类型包月套餐</div>
              <div>2）切换车辆类型包月套餐中的充电包月</div>
              <div>3）删除车辆类型包月套餐中的充电包月</div>
            </div>
            <el-form
              ref="params3"
              :model="params3"
              :rules="rules3"
              label-width="auto"
            >
              <el-row class="collapse_content" :gutter="10">
                <el-col :span="24">
                  <el-row
                    class="collapse_content_wrapper"
                    v-for="(item, index) in params3.monthlyInfoList"
                    :key="index"
                  >
                    <el-col :span="24">
                      <el-row>
                        <el-col class="wrapper_detail hidden-sm-and-up" :xs="24"
                          >价格详细</el-col
                        >

                        <el-col :span="7" :xs="24">
                          <el-form-item
                            :prop="'monthlyInfoList.' + index + '.name'"
                            :rules="rules3.name"
                          >
                            <el-input v-model="item.name" placeholder="请输入">
                              <template slot="prepend">车辆类型</template>
                            </el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="6" :xs="24" class="xs-m-p">
                          <el-form-item
                            :prop="'monthlyInfoList.' + index + '.money'"
                            :rules="rules3.money"
                          >
                            <el-input v-model="item.money" maxlength="8">
                              <template slot="prepend">停车收费</template>
                              <template slot="append">元</template>
                            </el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="7" :xs="24" class="xs-m-p">
                          <el-form-item
                            :prop="
                              'monthlyInfoList.' +
                              index +
                              '.chargeMonthlyInfoId'
                            "
                            :rules="rules3.chargeMonthlyInfoId"
                          >
                            <el-select
                              v-model="item.chargeMonthlyInfoId"
                              clearable
                              placeholder="请选择充电包月"
                            >
                              <el-option
                                v-for="item in chargeMonthlyInfoList"
                                :key="item.id"
                                :label="`最大功率${item.endPower}W,${item.money}元,${item.freeChargeNum}小时`"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>

                        <el-col :span="2" :xs="6" class="xs-m-p">
                          <el-button
                            v-if="listStart(index, 'params3')"
                            type="primary"
                            @click="addItem(item, 'params3')"
                          >
                            新增
                          </el-button>
                        </el-col>

                        <el-col :span="2" :xs="6" class="xs-m-p">
                          <el-button
                            v-if="listEnd(index, 'params3')"
                            type="danger"
                            @click="removeItem(item, params3.monthlyInfoList)"
                          >
                            删除
                          </el-button>

                          <el-button
                            v-if="listOnlyOne(index, 'params3')"
                            @click="resetItem('params3')"
                          >
                            重置
                          </el-button>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <div slot="footer">
        <el-button @click="noDialog">取 消</el-button>
        <el-button type="primary" @click="creatClick">确定</el-button>
      </div>
    </el-dialog>
    <map-dialog :dialog.sync="mapDialog" />
  </div>
</template>

<script>
import CarPort from "@/maintain/api/device/CarPort";
import maintainGetAccessControlInfoByQrcodeId from "@/maintain/api/device/access-control-device-controler/maintainGetAccessControlInfoByQrcodeId";
import maintainReplaceAccessControlDevice from "@/maintain/api/device/access-control-device-controler/maintainReplaceAccessControlDevice";
import maintainCreatCarport from "@/maintain/api/device/carport-controler/maintainCreatCarport";

import getGroupList from "@/maintain/api/device/device-group-manage/getGroupList";
import maintainGetGroupDetailById from "@/maintain/api/device/device-group-manage/maintainGetGroupDetailById";
import maintainGetOnlyChargeDeviceGroupIdNameList from "@/maintain/api/device/device-group-manage/maintainGetOnlyChargeDeviceGroupIdNameList";

import MapDialog from "@/components/Dialog/mapDialog";
import dialogMixin from "@/mixin/dialogMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";
import scanMixin from "@/mixin/scanMixin";
import templateMixin from "@/mixin/templateMixin/templateMixin";
import { Message } from "element-ui";
// import { Message } from "element-ui";

export default {
  name: "createAndEditCarportDialog",
  components: { MapDialog },
  mixins: [dialogMixin, resDisposeMixin, templateMixin, scanMixin],
  props: {
    id: Number,
    type: Number, //0:创建车库，1：新建车库
  },
  mounted() {
    this.refresh.$on("mapDialog", (records) => {
      this.params.address = records.detail.address;
      this.params.lat = records.detail.location.lat;
      this.params.lng = records.detail.location.lng;
      this.mapDialog = false;
    });
  },
  data() {
    return {
      mapDialog: false,
      activeCollapse: ["0", "1", "2"],

      params3: {
        monthlyInfoList: [
          {
            name: undefined,
            money: undefined,
            chargeMonthlyInfoId: undefined,
          },
        ],
      },
      params: {
        id: undefined,
        name: undefined,
        address: undefined,
        lat: undefined,
        lng: undefined,
        allowTemporaryParking: undefined,
        temporaryParkingMoney: undefined,
        temporaryParkingTime: undefined,
        groupId: undefined,
        accessControlDeviceList: [],
      },
      rules: {
        accessControlDeviceList: [
          {
            required: true,
            message: "请选择绑定的门禁设备",
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: "请输入地址",
            trigger: ["blur", "change"],
          },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: ["blur", "change"],
          },
        ],
        name: [
          { required: true, message: "请输入名字", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        groupId: [
          {
            required: true,
            message: "请选择小区",
            trigger: ["blur", "change"],
          },
        ],
      },
      devices: [],
      templates: [],
      groupList: [],
      chargeMonthlyInfoList: [],
      allowTemporaryParking: true,
    };
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        if (this.type == 0) {
          this.$nextTick(() => {
            this.allowTemporaryParking = true;
            this.$refs["params"].resetFields();
          });
        }
        this.fetchData();
      }
    },
    "params.groupId": {
      handler(newV) {
        if (!newV) return;
        maintainGetGroupDetailById({ id: newV }).then((res) => {
          this.chargeMonthlyInfoList = res.data.monthlyInfoList;
        });
      },
    },
  },
  methods: {
    closeReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    handleScanGetAccessDevice() {
      this.$message.warning("功能开发中，请直接选择~");
    },
    scanNewQrcode() {
      return new Promise((resolve, reject) => {
        this.scan({
          callBack: (res) => {
            const isLink = res.resultStr.substring(0, 4) === "http";

            if (!isLink) {
              return this.$message.error("请扫门禁设备的二维码~");
            }
            let strList = res.resultStr.split("?");
            if (strList.length === 2) {
              let argList = strList[1].split("&");
              if (argList.length === 3) {
                if (argList[0].startsWith("accessControlDeviceId=")) {
                  resolve(argList[0].split("=")[1]);
                } else {
                  Message.error("二维码错误");
                  reject();
                }
              } else {
                Message.error("二维码错误");
                reject();
              }
            } else {
              Message.error("二维码错误");
              reject();
            }
          },
        });
      });
    },
    handleScanGetEnterDoorAccessDevice() {
      this.scanNewQrcode().then((res) => {
        // 门禁是否已存在
        if (
          this.params.accessControlDeviceList.find(
            (a) => a.accessControlDeviceQrCode.id == res
          )
        ) {
          return Message.error("请勿重复添加!");
        }
        this.params.accessControlDeviceList.push({
          direction: 1,
          accessControlDeviceQrCode: { id: res },
        });
        Message.success("门禁添加成功~");
      });
    },
    handleScanGetOutDoorAccessDevice() {
      this.scanNewQrcode().then((res) => {
        // 门禁是否已存在
        if (
          this.params.accessControlDeviceList.find(
            (a) => a.accessControlDeviceQrCode.id == res
          )
        ) {
          return Message.error("请勿重复添加!");
        }
        this.params.accessControlDeviceList.push({
          direction: 2,
          accessControlDeviceQrCode: { id: res },
        });
        Message.success("门禁添加成功~");
      });
    },
    replaceAccessControl(row) {
      this.scanNewQrcode().then((res) => {
        if (row.accessControlDeviceQrCode.id == res) {
          return Message.error("请勿更换同一设备!");
        }
        // TODO 通过扫码获取的二维码ID获取门禁设备主键ID
        maintainGetAccessControlInfoByQrcodeId(res).then((res) => {
          // 更换门禁
          maintainReplaceAccessControlDevice(row.id, res.data).then((res) => {
            Message({
              message: res.code === 1 ? "更换成功~" : "更换失败!",
              type: res.code === 1 ? "success" : "error",
              duration: 3 * 1000,
            });
          });
        });
      });
    },
    delAccessControl(row) {
      const index = this.params.accessControlDeviceList.findIndex(
        (a) =>
          a.accessControlDeviceQrCode.id == row.accessControlDeviceQrCode.id
      );
      this.params.accessControlDeviceList.splice(index, 1);
    },
    handleCloseDialog() {
      this.$refs["params"].resetFields();
      this.chargeMonthlyInfoList = [];
      this.$refs["params3"].resetFields();
    },
    fetchData() {
      //清空选中数据
      // this.params.accessControlDeviceList.splice(
      //   0,
      //   this.params.accessControlDeviceList.length
      // );

      this.$set(this.params3, "monthlyInfoList", [
        {
          name: undefined,
          money: undefined,
          chargeMonthlyInfoId: undefined,
        },
      ]);
      this.$nextTick(() => {
        this.$refs["params3"].resetFields();
      });

      if (this.type === 0) {
        this.params.accessControlDeviceList = [
          // {
          //   accessControlDeviceQrCode: { id: 35 },
          //   direction: 1,
          // },
        ];
        maintainGetOnlyChargeDeviceGroupIdNameList().then((res) => {
          this.groupList = res.data;
        }); 
      } else {
        this.loadStart();

        getGroupList().then((res) => {
          this.groupList = res.data;
        }); 
        CarPort.maintainGetCarportById({ carportId: this.id })
          .then((res) => {
            this.getDataResDispose({
              res,
              success: () => {
                this.params.id = res.data.id;
                this.params.name = res.data.name;
                this.params.address = res.data.address;
                this.params.lat = res.data.lat;
                this.params.lng = res.data.lng;
                this.params.allowTemporaryParking =
                  res.data.allowTemporaryParking;
                this.params.temporaryParkingMoney =
                  res.data.temporaryParkingMoney;
                this.params.temporaryParkingTime =
                  res.data.temporaryParkingTime;
                this.allowTemporaryParking =
                  res.data.allowTemporaryParking === 1;
                this.params.groupId =
                  res.data.groupId == 0 ? undefined : res.data.groupId;
                this.params.accessControlDeviceList =
                  res.data.accessControlDeviceList;
                //设置选中数据
                // for (let key in res.data.accessControlDeviceList) {
                // this.devices.push(res.data.accessControlDeviceList[key]);
                //   this.params.accessControlDeviceList.push(
                //     res.data.accessControlDeviceList[key].id
                //   );
                // }
                // 设置车辆类型包月套餐列表
                if (
                  res.data.agentGetCarTypeMonthlyInfoList &&
                  res.data.agentGetCarTypeMonthlyInfoList.length
                ) {
                  this.params3.monthlyInfoList =
                    res.data.agentGetCarTypeMonthlyInfoList.map((a) => ({
                      ...a,
                      chargeMonthlyInfoId: a.chargeMonthlyInfoId || undefined,
                    }));
                }
              },
            });
          })
          .finally(() => {
            this.loadDialog.close();
          });
      }
    },
    creatClick() {
      if (!this.params.lat) {
        this.$message.error("请先通过点击定位获取位置信息~");
        return;
      }

      if (!this.params.accessControlDeviceList.length) {
        this.$message.error("请先扫码添加门禁设备~");
        return;
      }

      this.$refs["params"].validate((valid) => {
        if (valid) {
          this.params.allowTemporaryParking = this.allowTemporaryParking
            ? 1
            : 0;

          if (
            this.allowTemporaryParking &&
            (this.params.temporaryParkingTime === undefined ||
              this.params.temporaryParkingTime <= 0)
          ) {
            this.$message.error("临停时长不能小于1");
            return;
          }

          if (
            this.allowTemporaryParking &&
            (this.params.temporaryParkingMoney === undefined ||
              this.params.temporaryParkingMoney < 0)
          ) {
            this.$message.error("临停收费金额不能小于0");
            return;
          }

          if (
            this.params3.monthlyInfoList.length === 1 &&
            (!this.params3.monthlyInfoList[0].name ||
              this.params3.monthlyInfoList[0].money === undefined)
          ) {
            delete this.params3.monthlyInfoList;
          } else {
            for (const month of this.params3.monthlyInfoList) {
              if (month.name === undefined || month.name.trim() == "") {
                return this.$message.error("请输入车辆类型名称");
              }
              if (month.money === undefined || +month.money <= 0) {
                return this.$message.error("包月套餐金额必须大于0");
              }
            }
          }

          this.loadStart();

          let that = this;
          if (this.type === 0) {
            maintainCreatCarport({
              ...this.params,
              agentCreateCarTypeMonthlyInfoList: this.params3.monthlyInfoList,
            })
              .then((res) => {
                this.resDispose({
                  res,
                  success: function () {
                    that.noDialog();
                    that.$parent.fetchData();
                    that.$parent.fetchGetAccessControlDeviceNumDateil();
                  },
                });
              })
              .finally(() => {
                this.loadDialog.close();
              });
          } else {
            if (!this.params.groupId) {
              this.params.groupId = 0;
            }
            CarPort.maintainEditCarport({
              ...this.params,
              agentEditCarTypeMonthlyInfoList: this.params3.monthlyInfoList,
            })
              .then((res) => {
                this.resDispose({
                  res,
                  success: function () {
                    that.noDialog();
                    that.$parent.fetchData();
                    that.$parent.fetchGetAccessControlDeviceNumDateil();
                  },
                });
              })
              .finally(() => {
                this.loadDialog.close();
              });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "src/styles/my";
@include mobile {
  .collapse_content {
    .collapse_content_wrapper {
      margin-bottom: 10px;
    }
  }

  .wrapper_detail {
    margin-bottom: 0.3125rem;
  }
}

.collapse_label {
  font-size: 14px;
  color: #606266;
  font-weight: bold;
  display: flex;
  align-items: center;
  .label_icon {
    margin-right: 0.5rem;
    font-size: 1.25rem;
    font-weight: 100;
  }
}

.col_line {
  height: 2.5rem;
  line-height: 2.5rem;
  text-align: center;
}

.collapse_content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0.625rem 0;

  /deep/ .el-form-item {
    margin-bottom: 0 !important;
  }

  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  .collapse_content_wrapper {
    display: flex;
    align-items: center;
  }

  .content_title {
    margin-right: 10px;
  }
}

.enter_door_wrapper,
.out_door_wrapper {
  .door_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    border: 1px solid #eee;
    border-radius: 10px;
    box-shadow: 1px 1px 4px #ddd;
    margin: 4px;
  }
}
</style>
